import { useContext } from "react";
import { Button } from "capitalrx-components-2.0/lib/general";
import { Paragraph, Heading } from "capitalrx-components-2.0/lib/typography";
import { Grid, Stack } from "capitalrx-components-2.0/lib/layout";
import cn from "classnames";
import { ThemeSelectorContext } from "@/context/index";

import styles from "./Error.module.scss";

interface Props {
  type: string;
}

const ErrorMessageBody = ({ type }: Props): JSX.Element => {
  const { client } = useContext(ThemeSelectorContext);

  const backButtonClassName = cn({
    [styles.RejectBack]: type === "reject",
    [styles.WhitelabelButton]: !!client,
  });

  if (type === "reject") {
    return (
      <>
        <Heading level={3}>Your request cannot be processed at this time.</Heading>
        <div className={styles.ErrorDescription}>
          <div className={styles.ErrorDescriptionReject}>
            <Paragraph>There are two common causes of this:</Paragraph>
            <ul className={styles.ErrorDescriptionList}>
              <li>The drug entered is not eligible for discounts under the Advantage program.</li>
              <li>The quantity exceeds the limits on this medication.</li>
            </ul>
            <Paragraph>If you would like to try again, please change the drug or adjust the quantity.</Paragraph>
            <Button className={backButtonClassName} appearance="primary" icon="arrow-left" iconPosition="left">Go Back</Button>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className={styles.ErrorContainer} data-testid="error-container">
        <Grid className={styles.Error}>
          <Grid.Spread columns={12}>
            <Stack>
              <Heading level={2}>Something went wrong!</Heading>
              <div className={styles.ErrorDescription}>
                <Paragraph>
                  We apologize for the inconvenience. Please refresh the page and if the problem persists, check back later.
                </Paragraph>
              </div>
            </Stack>
          </Grid.Spread>
        </Grid>
      </div>
    );
  }
};

export default ErrorMessageBody;
